import {
  SMART_REVIEW_STEP_ORDER,
  SmartReviewStep,
} from './SmartReviewOnboardingModal.types';

function getStorageKey(householdId: string) {
  return `user-dismissed-smart-review-${householdId}-step`;
}

export function getDismissedSmartReviewStep(
  householdId: string
): SmartReviewStep | null {
  const value = localStorage.getItem(getStorageKey(householdId));
  return SMART_REVIEW_STEP_ORDER.find((step) => step === value) ?? null;
}

export function setDismissedSmartReviewStep(
  householdId: string,
  step: SmartReviewStep
) {
  localStorage.setItem(getStorageKey(householdId), step);
}

export function clearDismissedSmartReviewStep(householdId: string) {
  localStorage.removeItem(getStorageKey(householdId));
}
